import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import styles from './step.scss';

const Step = ({ document, order }) => {
  const {
    fields: { images, description, title },
  } = document;

  const image = images[0].fields;

  return (
    <li className={styles.step}>
      <div className={styles.imgWrapper}>
        <img
          className={styles.stepImage}
          src={`${image.file.url}?fm=webp`}
          alt={image.description || ''}
          aria-hidden="true"
        />
      </div>
      <div className={styles.content}>
        <p className={styles.orderNumber}>{order}.</p>
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.description}>
          {documentToReactComponents(description)}
        </div>
      </div>
    </li>
  );
};

export default Step;
